import React, {Fragment, ReactElement} from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@components/common/headers/ModalHeader';

// Constants

import { configs } from '@constants/configs/configs';

// Types

import { CommonModalProps } from '../SsapTypes';
import { History } from 'history';

interface IUndoMemberRemovalModal extends CommonModalProps {
    modal: {
        modalData: {
            history: History
        }
    }
}

const UndoMemberRemovalModal = (props: IUndoMemberRemovalModal): ReactElement => {

    const {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                history: {
                    push
                }
            }
        },
        modalHeaderProps,
        modalHeaderProps: {
            modalId
        }
    } = props;

    const handleGoToDashboardClick = (): void => {
        hideModal();
        push(configs.routes.INDPORTAL);
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head' >
                <ModalHeader { ...modalHeaderProps } />
            </div>
            <div id = 'undoMemberRemovalModal' className = 'gi-modal__body' >
                <span data-testid={`${modalId}_body`}>
                    <FormattedMessage
                        id = 'modals.undo_member_removal.content'
                        values = { {
                            strong: chunks => <strong>{chunks}</strong>
                        } }
                    />
                </span>
            </div>
            <div className = 'gi-modal__footer' >
                <div className = 'grid-row controls' >
                    <div className = 'grid-offset-4 txt-left' >
                        <Button
                            className = 'usa-button usa-button--outline gi-button gi-button__outline'
                            data-testid={`${modalId}-close_btn`}
                            onClick = { hideModal }
                        >
                            <FormattedMessage id = 'button.close' />
                        </Button>
                        <Button
                            className = 'usa-button gi-button gi-button__primary'
                            data-testid={`${modalId}-go-to-dashboard_btn`}
                            onClick = { handleGoToDashboardClick }
                            inputRef = { boundAnchor(anchor_1) }
                        >
                            <FormattedMessage id = 'button.go_to_dashboard_ssap' />
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default UndoMemberRemovalModal;